/**
 * Display period dates as mm/dd/yyyy (avoids raw ISO / Z in UI).
 */

export function formatPeriodDate(value) {
  if (value == null || value === '') return '';
  const raw = String(value).trim();
  const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    return `${month}/${day}/${year}`;
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  const year = parsed.getFullYear();
  return `${month}/${day}/${year}`;
}

export function formatPeriodDateRange(start, end) {
  const startLabel = formatPeriodDate(start);
  const endLabel = formatPeriodDate(end);
  if (startLabel && endLabel) return `${startLabel} – ${endLabel}`;
  if (startLabel && !endLabel) return `${startLabel} – open`;
  return startLabel || endLabel || '';
}
